import {createAction} from '@ngrx/store';
import {
  ActiveFilterCollection,
  Colors,
  DiameterRange,
  Shape,
  Material,
  PriceRange,
  ProductCategories,
  ProductSections,
  Style, VolumeRange, Brands
} from '../../interfaces/filter.interface';


export const SelectProductSections = createAction(
  '[FILTER] SELECT_PRODUCT_SECTIONS',
  (payload: ProductSections) => payload
);

export const SelectProductCategories = createAction(
  '[FILTER] SELECT_PRODUCT_CATEGORIES',
  (payload: ProductCategories) => payload
);

export const SelectColors = createAction(
  '[FILTER] SELECT_COLORS',
  (payload: Colors) => payload
);
export const SelectShapes = createAction(
  '[FILTER] SELECT_SHAPE',
  (payload: Shape) => payload
);

export const SelectMaterial = createAction(
  '[FILTER] SELECT_MATERIAL',
  (payload: Material) => payload
);
export const SelectBrand = createAction(
  '[FILTER] SELECT_BRAND',
  (payload: Brands) => payload
);

export const SelectStyle = createAction(
  '[FILTER] SELECT_STYLE',
  (payload: Style) => payload
);

export const SetPriceRange = createAction(
  '[FILTER] SET_PRICE_RANGE',
  (payload: PriceRange) => payload
);

export const SetVolumeRange = createAction(
  '[FILTER] SET_CONTENT_RANGE',
  (payload: VolumeRange) => payload
);

export const SetDiameterRange = createAction(
  '[FILTER] SET_DIAMETER_RANGE',
  (payload: DiameterRange) => payload
);
export const CollectFilters = createAction(
  '[FILTER] COLLECT_FILTERS',
  (payload: ActiveFilterCollection) => payload
);
export const ResetFilters = createAction(
  '[FILTER] RESET_FILTERS',
);
